/* eslint-disable
    guard-for-in,
    no-restricted-syntax
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import DataRecoveryModalClass from 'notebook/store/data-recovery/DataRecoveryModal';
import notifications from 'notifications';
import * as ModalContainer from 'ui-library/ModalContainer';
import drafts from 'notebook/store/data-recovery/Drafts';
import ifCreateFromHash from 'util/ifCreateFromHash';

function dismiss() {
  const localDrafts = drafts.getLocalDrafts();
  for (const draftId in localDrafts) {
    const draft = localDrafts[draftId];
    if (drafts.isRecoverable(draft)) {
      localDrafts[draftId].dismissed = true;
    }
  }
  drafts.setLocalDrafts(localDrafts);
}

function checkHash() {
  ifCreateFromHash(drafts.RECOVERY_HASH, () => {
    analytics.track('data_recovery', 'open_modal');
    ModalContainer.open(
      DataRecoveryModalClass,
      <DataRecoveryModalClass
        onRequestClose={function () {
          ModalContainer.close(DataRecoveryModalClass);
        }}
        onDismiss={dismiss}
      />
    );
  });
}

class DataRecoveryHashView extends Backbone.View {
  render() {
    if (drafts.recoverableDataExist()) {
      analytics.track('data_recovery', 'see_prompt');
      notifications.warn(
        <div>
          We recovered unsaved changes to your files. <a href={drafts.RECOVERY_HASH}>Click here</a> to recover
          this data.
        </div>,
        {duration: 0, id: drafts.RECOVERY_ID, onClose: dismiss}
      );
    }

    $(window).on('hashchange', checkHash);
    checkHash();
  }
}

export default DataRecoveryHashView;
